import React from 'react';

export default function StudentVeteranGroupModalContent() {
  return (
    <>
      <p>Does this school have a student-led Veteran group on campus?</p>
      <p>
        If a school has a student Veterans group that’s not represented here,
        please notify us by email at{' '}
        <a
          title="224A.VBAVACO@va.gov"
          href="mailto: 224A.VBACO@va.gov?subject=Comparison Tool"
        >
          224A.VBAVACO@va.gov
        </a>
        . We update this information in the Comparison Tool quarterly.
      </p>
      <p>
        Please note this email address is only for tool-related issues. For
        questions about your GI Bill benefits,{' '}
        <a href="/contact-us/">contact us online through Ask VA</a>.
      </p>
    </>
  );
}
